import { lazyWithRetry } from "utils/lazy-with-retry";

const DraftOverview = lazyWithRetry(() => import("./DraftOverview"));

export default DraftOverview;
